import { Injectable } from '@angular/core';
import { AppRoutes, CartFlowStages } from '@ciptech/constants'
import { CartStorageDto, CartFlowValidation } from '@ciptech/commons/dto';
import { CartEventCode } from '@ciptech/classes/event.model';

@Injectable({
	providedIn: 'root'
})
export class CartFlowService {
	constructor() { }
	hasProducts(cart: CartStorageDto | null | undefined): boolean {
		return !!cart?.items?.length;
	}

	hasValidCheckout(cart: CartStorageDto | null | undefined): boolean {
		if (!cart?.checkout)
			return false;
		if (cart.checkout.IdFormaEnvio == 2 && !cart.checkout.IdDireccionCipsa)
			return false;
		return true;
	}

	hasValidConfirmation(cart: CartStorageDto | null | undefined): boolean {
		return !!cart?.confirmation;
	}

	validateStage(cart: CartStorageDto | null | undefined, stage: CartFlowStages): CartFlowValidation {
		switch (stage) {
			case CartFlowStages.PRODUCTS:
			case CartFlowStages.CHECKOUT:
				if (!this.hasProducts(cart)) {
					return {
						valid: false,
						redirect: AppRoutes.STORE
					};
				}
				return {
					valid: true,
					redirect: null
				};
			case CartFlowStages.PAYMENT:
				if (!this.hasProducts(cart)) {
					return {
						valid: false,
						redirect: AppRoutes.STORE
					};
				}
				if (!this.hasValidCheckout(cart)) {
					return {
						valid: false,
						redirect: AppRoutes.CART
					};
				}
				return {
					valid: true,
					redirect: null
				};
			case CartFlowStages.CONFIRMATION:

				if (!this.hasValidConfirmation(cart)) {
					return {
						valid: false,
						redirect: AppRoutes.STORE
					};
				}

				return {
					valid: true,
					redirect: null
				};

			default:
				return {
					valid: false,
					redirect: AppRoutes.CART
				};
		}
	}

	validateCartChange(cart: CartStorageDto | null | undefined, stage: CartFlowStages, eventCode: CartEventCode | null | undefined): CartFlowValidation {
		const stageValidation = this.validateStage(cart, stage);
		if (!stageValidation.valid)
			return stageValidation;
		switch (eventCode) {
			case CartEventCode.ProductsAdded:
				return {
					valid: false,
					redirect: AppRoutes.CART
				};
			case CartEventCode.ProductsConfirmed:
				return {
					valid: false,
					redirect: AppRoutes.CART_CHECKOUT
				};
			case CartEventCode.CheckoutConfirmed:
				return {
					valid: false,
					redirect: AppRoutes.CART_PAYMENT
				};
			case CartEventCode.PaymentConfirmed:
				return {
					valid: false,
					redirect: AppRoutes.CART_CONFIRMATION
				};
			default:
				return {
					valid: true,
					redirect: null
				};
		}
	}
}
